export default function MetaProgressBar({ label, current, target, unit = "", color = "bg-neutral-950" }) {
  const pct = target > 0 ? Math.min((current / target) * 100, 100) : 0;
  const over = target > 0 && current > target;
  return (
    <div>
      {label && (
        <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-widest text-neutral-600 mb-1">
          <span>{label}</span>
          <span>
            {current}
            {unit} / {target}
            {unit} · {pct.toFixed(1)}%
          </span>
        </div>
      )}
      <div className="relative h-3 bg-neutral-200 border border-neutral-900 overflow-hidden">
        <div
          className={`absolute inset-y-0 left-0 ${over ? "bg-green-600" : color} transition-all`}
          style={{ width: `${pct}%` }}
        />
        {target > 0 && pct < 100 && (
          <div
            className="absolute inset-y-0 border-r-2 border-dashed border-neutral-500"
            style={{ left: "100%" }}
          />
        )}
      </div>
    </div>
  );
}
